'use client';

import { c as _c } from "react/compiler-runtime";
import { BackersTab } from '@/components/social/leaderboard/backers-tab';
import { BoostersTab } from '@/components/social/leaderboard/boosters-tab';
import { CreatorsTab } from '@/components/social/leaderboard/creators-tab';
import { LeaderboardTab } from '@/components/social/leaderboard/leaderboard-tab';
import { TabErrorBoundary } from '@/components/social/shared/tab-error-boundary';
import type { BackerSort, BoosterSort, CreatorSort, PnlSort, SocialTab, TabJump } from '@/components/social/types';
import { TabsContent } from '@/components/ui/app-tabs';
interface SocialBoardPanelsProps {
  /** Active time window forwarded to every board's leaderboard query. */
  timeWindow: string;
  /** Per-tab anchor-jump + pulse, driven by the floating rank bar. */
  tabJumps: Record<SocialTab, TabJump>;
  pnlSort: PnlSort;
  boosterSort: BoosterSort;
  creatorSort: CreatorSort;
  backerSort: BackerSort;
  onPnlSortChange: (next: PnlSort) => void;
  onBoosterSortChange: (next: BoosterSort) => void;
  onCreatorSortChange: (next: CreatorSort) => void;
  onBackerSortChange: (next: BackerSort) => void;
}

// The four leaderboard boards, one per `<TabsContent>`. Extracted from
// SocialClient so the parent stays focused on URL/optimistic state. Radix
// `<TabsContent>` reads the active value from `<Tabs>` context, so it works
// correctly when nested through this component rather than a direct child.
export function SocialBoardPanels(t0) {
  const $ = _c(29);
  const {
    timeWindow,
    tabJumps,
    pnlSort,
    boosterSort,
    creatorSort,
    backerSort,
    onPnlSortChange,
    onBoosterSortChange,
    onCreatorSortChange,
    onBackerSortChange
  } = t0;
  let t1;
  if ($[0] !== onPnlSortChange || $[1] !== pnlSort || $[2] !== tabJumps.leaderboard.anchor || $[3] !== tabJumps.leaderboard.pulse || $[4] !== timeWindow) {
    t1 = <TabsContent value="leaderboard" className="mt-0"><TabErrorBoundary tabName="leaderboard"><LeaderboardTab initialSort={pnlSort} onSortChange={onPnlSortChange} anchorUserId={tabJumps.leaderboard.anchor} pulseTick={tabJumps.leaderboard.pulse} timeWindow={timeWindow} /></TabErrorBoundary></TabsContent>;
    $[0] = onPnlSortChange;
    $[1] = pnlSort;
    $[2] = tabJumps.leaderboard.anchor;
    $[3] = tabJumps.leaderboard.pulse;
    $[4] = timeWindow;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== boosterSort || $[7] !== onBoosterSortChange || $[8] !== tabJumps.boosters.anchor || $[9] !== tabJumps.boosters.pulse || $[10] !== timeWindow) {
    t2 = <TabsContent value="boosters" className="mt-0"><TabErrorBoundary tabName="boosters"><BoostersTab initialSort={boosterSort} onSortChange={onBoosterSortChange} anchorUserId={tabJumps.boosters.anchor} pulseTick={tabJumps.boosters.pulse} timeWindow={timeWindow} /></TabErrorBoundary></TabsContent>;
    $[6] = boosterSort;
    $[7] = onBoosterSortChange;
    $[8] = tabJumps.boosters.anchor;
    $[9] = tabJumps.boosters.pulse;
    $[10] = timeWindow;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  let t3;
  if ($[12] !== creatorSort || $[13] !== onCreatorSortChange || $[14] !== tabJumps.creators.anchor || $[15] !== tabJumps.creators.pulse || $[16] !== timeWindow) {
    t3 = <TabsContent value="creators" className="mt-0"><TabErrorBoundary tabName="creators"><CreatorsTab initialSort={creatorSort} onSortChange={onCreatorSortChange} anchorUserId={tabJumps.creators.anchor} pulseTick={tabJumps.creators.pulse} timeWindow={timeWindow} /></TabErrorBoundary></TabsContent>;
    $[12] = creatorSort;
    $[13] = onCreatorSortChange;
    $[14] = tabJumps.creators.anchor;
    $[15] = tabJumps.creators.pulse;
    $[16] = timeWindow;
    $[17] = t3;
  } else {
    t3 = $[17];
  }
  let t4;
  if ($[18] !== backerSort || $[19] !== onBackerSortChange || $[20] !== tabJumps.backers.anchor || $[21] !== tabJumps.backers.pulse || $[22] !== timeWindow) {
    t4 = <TabsContent value="backers" className="mt-0"><TabErrorBoundary tabName="backers"><BackersTab initialSort={backerSort} onSortChange={onBackerSortChange} anchorUserId={tabJumps.backers.anchor} pulseTick={tabJumps.backers.pulse} timeWindow={timeWindow} /></TabErrorBoundary></TabsContent>;
    $[18] = backerSort;
    $[19] = onBackerSortChange;
    $[20] = tabJumps.backers.anchor;
    $[21] = tabJumps.backers.pulse;
    $[22] = timeWindow;
    $[23] = t4;
  } else {
    t4 = $[23];
  }
  let t5;
  if ($[24] !== t1 || $[25] !== t2 || $[26] !== t3 || $[27] !== t4) {
    t5 = <>{t1}{t2}{t3}{t4}</>;
    $[24] = t1;
    $[25] = t2;
    $[26] = t3;
    $[27] = t4;
    $[28] = t5;
  } else {
    t5 = $[28];
  }
  return t5;
}